import React from "react";
import AreaSearchBox from "../AreaSearchBox";

/**
 * Sidebar component for area selection with search
 * Handles mobile toggle and area search functionality
 * 
 * @param {boolean} isSidebarOpen - Sidebar open state
 * @param {Function} setIsSidebarOpen - Setter for sidebar state
 * @param {Array} areas - List of all areas
 * @param {Array} filteredAreas - Filtered areas list
 * @param {Function} setFilteredAreas - Setter for filtered areas
 * @param {Object} images - Map of area images
 * @param {Function} handleView - Handler for area selection
 * @param {boolean} isSpeciesListOpen - Whether species list is open (to hide toggle on mobile)
 */
export default function AreaSidebar({
    isSidebarOpen,
    setIsSidebarOpen,
    areas,
    filteredAreas,
    setFilteredAreas,
    images,
    handleView,
    isSpeciesListOpen
}) {
    return (
        <>
            {/* Mobile Sidebar Toggle Button */}
            {!isSpeciesListOpen && (
                <button
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    className="md:hidden absolute top-6 z-30 bg-offwhite shadow-lg rounded-r-md px-1 py-6 flex flex-col items-center gap-2 hover:bg-sage/20 transition-colors"
                >
                    <svg 
                        className={`w-5 h-5 text-forest transition-transform ${isSidebarOpen ? 'rotate-180' : ''}`}
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    <span className="text-md font-semibold text-forest whitespace-nowrap" style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}>
                        Naturområden
                    </span>
                </button>
            )}

            {/* Search Box - Floating on top left, hidden by default on mobile, slides in when toggled */}
            <div 
                className="absolute top-6 left-8 w-64 md:w-80 z-10 duration-300 ease-in-out"
                style={{ 
                    transform: window.innerWidth >= 768 ? 'translateX(0)' : (isSidebarOpen ? 'translateX(0)' : 'translateX(-150%)'),
                    transition: 'transform 0.3s ease-in-out'
                }}
            >
                <AreaSearchBox 
                    areas={areas || []}
                    filteredAreas={filteredAreas}
                    setFilteredAreas={setFilteredAreas}
                    images={images}
                    handleView={handleView}
                    closeSidebar={() => setIsSidebarOpen(false)}
                />
            </div>
        </>
    );
}
